import {Component, OnDestroy, OnInit} from "@angular/core";
import {SubscriptionService} from "../../../subscription/subscription.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BuyService} from "../../../buy/buy.service";
import {Model} from "../../../app.model";
import {CompanyService} from "../../../company/company.service";
import {WorkflowEndcustomerService} from "../workflow-endcustomer.service";
import {WorkflowEndcustomerChangeCuComponent} from "../workflow-endcustomer-change-cu.component";

/**
 * Workflow to upgrade CUs as a customer
 */
@Component({
    selector: 'app-workflow-endcustomer-one-downgrade-cu',
    templateUrl: './workflow-endcustomer-one-downgrade-cu.component.html',
    standalone: false
})
export class WorkflowEndcustomerOneDowngradeCuComponent extends WorkflowEndcustomerChangeCuComponent implements OnInit, OnDestroy {
  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected subscriptionService: SubscriptionService,
              protected buyService: BuyService,
              protected m: Model,
              protected workflowEndcustomerService: WorkflowEndcustomerService,
              protected companyService: CompanyService) {
    super(route, router, subscriptionService, buyService, m, workflowEndcustomerService, companyService);
  }

  async ngOnInit() {
    super.ngOnInit();
    await this.initWorkflow('downgrade-cu');

    this.checkOnInitPaymentStep(['address']);
    
    this.initialized = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  protected checkSelectedProduct(ifStatement: boolean) {
    return +this.model.subscription.users === this.model.cu
      || +this.model.subscription.users < this.model.cu
  }

  public onDowngradeInfo(e: any) {
    this.navigate(['address']);
  }

  public onDowngradeInfoBack() {
    // Switch to workflow change cu
    this.router.navigate(['/do', 'change-cu', this.applianceId]);
  }

  public onInvoiceAddressBack() {
    this.navigate(['info']);
  }

  public onPaymentMethodBack() {
    this.navigate(['address']);
  }

  public onBuy() {
    this.buyService.confirmUpgrade().subscribe(
      (saleOrder: any) => {
        this.navigate(['complete'])
      }
    );
  }
}
